// /store/modules/rawrawLead.js
import apiClient from '../../plugins/axios';
import router from "../../router";

export default {
  namespaced: true,
  state: () => ({
    rawLead: null,
    loading: false,
    rawLeadDialog: false,
    uploads: null,
  }),
  mutations: {
    setRawLead(state, rawLead) {
      state.rawLead = rawLead;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setRawLeadDialog(state, rawLeadDialog) {
      state.rawLeadDialog = rawLeadDialog;
    },
    resetRawLead(state) {
      state.rawLead = null;
      state.uploads = null;
    },
  },
  actions: {
    async fetchRawLeadData({ commit }, rawLeadId) {
      commit("setLoading", true);
      try {
        const response = await apiClient.get(
          `/getters/getRawLeadById?rawLeadId=${rawLeadId}`
        );
        commit("setRawLead", response.data);
        commit("setRawLeadDialog", true);
      } catch (error) {
        console.error("Failed to fetch rawLead data:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    setRawLeadDialog({ commit }, rawLeadDialog) {
      commit("setRawLeadDialog", rawLeadDialog);
    },
    closeRawLeadDialog({ commit, rootState }) {
      router.replace(rootState.agency.dialogReturnRoute);
      commit("resetRawLead");
      commit("setRawLeadDialog", false);
    },
    resetRawLead({ commit }) {
      commit("resetRawLead");
    }
  },
};
